/**
 * Display labels + tone mapping for the compliance-manual builder. Kept in one
 * place so the overview, section editor, and package read consistently.
 */
import type { DocumentStatus } from "@/lib/api/manuals";
import type { SectionApplicability, SectionDerivation, SectionReviewStatus } from "@argus/engine";

type Tone = "neutral" | "brand" | "clear" | "risk" | "breach" | "info" | "ai";

export const MANUAL_STATUS_LABEL: Record<DocumentStatus, string> = {
  draft: "Draft",
  in_review: "In review",
  adopted: "Adopted",
  archived: "Archived",
};

export const MANUAL_STATUS_TONE: Record<DocumentStatus, Tone> = {
  draft: "neutral",
  in_review: "info",
  adopted: "clear",
  archived: "neutral",
};

export const APPLICABILITY_LABEL: Record<SectionApplicability, string> = {
  applicable: "Applicable",
  recommended: "Recommended",
  not_applicable: "Not applicable",
};

export const APPLICABILITY_TONE: Record<SectionApplicability, Tone> = {
  applicable: "brand",
  recommended: "info",
  not_applicable: "neutral",
};

export const SECTION_SOURCE_LABEL: Record<SectionDerivation, string> = {
  auto: "From Argus",
  ai: "AI draft",
  manual: "Authored",
};

export const SECTION_SOURCE_TONE: Record<SectionDerivation, Tone> = {
  auto: "clear",
  ai: "ai",
  manual: "neutral",
};

export const SECTION_SOURCE_HINT: Record<SectionDerivation, string> = {
  auto: "Pre-filled from Argus's own side-letter / MFN administration.",
  ai: "Drafted by Claude (or the deterministic fallback) and tailored to your firm — accept or edit.",
  manual: "Authored by your team.",
};

export const SECTION_REVIEW_LABEL: Record<SectionReviewStatus, string> = {
  unreviewed: "Needs review",
  accepted: "Accepted",
  edited: "Edited",
  flagged: "Flagged",
};

export const SECTION_REVIEW_TONE: Record<SectionReviewStatus, Tone> = {
  unreviewed: "risk",
  accepted: "clear",
  edited: "info",
  flagged: "breach",
};
